module.exports = __webpack_public_path__ + "static/media/pizza-slice.502b2188.svg";